import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Modal, Backdrop, Grid, CircularProgress } from "@mui/material";
import { FiX } from "react-icons/fi";
import Link from "next/link";
import Select from "react-select";
import { ReactSVG } from "react-svg";
import { getAssets, swalError, swalSuccess } from "@unisearch/helpers";
import { Formik, Form, Field, ErrorMessage } from "formik";
import API from "@unisearch/helpers/api";
import StudentProfileInput from "@unisearch/common/ui_element/student_profile_input";
import styles from "./form.module.scss";

const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "13px 20px",
    border: "1px solid #eee",
    fontWeight: 500,
    fontSize: "14px",
    boxShadow: state.isFocused ? "none" : "none",

    // boxShadow: state.isFocused
    //   ? "0px 5px 11px rgba(150, 185, 255, 0.25)"
    //   : "0px 2px 5px rgba(38, 51, 77, 0.03)",
    borderColor: "none",
    "&:hover": { borderColor: "none" },
    borderColor: state.isFocused ? "#fff" : "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    position: "relative",
    zIndex: "2",
    fontSize: "14px",
    cursor: "pointer",
    color: state.isSelected ? "#F47F20" : "#B5B5C3",
    backgroundColor: state.isSelected
      ? "#F5F6FC"
      : state.isFocused
      ? "#fff"
      : provided.backgroundColor,
    "&:hover": {
      backgroundColor: "#F5F6FC",
      color: "#F47F20",
    },
  }),
};

const _init = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  fromCountryId: undefined,
  preferredCountryId: undefined,
  levelId: undefined,
  counsellingTimeId: undefined,
  preferredMonthYear: "",
  counsellingDate: "",
  terms_and_condition1: false,
  terms_and_condition2: false,
  terms_and_condition3: false,
};

export const VOfficeForm = () => {
  const [virtualState, setVirtualState] = useState(_init);
  const [allCountry, setAllCountry] = useState([]);
  const [workableCountry, setWorkableCountry] = useState([]);
  const [studyLevel, setStudyLevel] = useState([]);
  const [plan, setPlan] = useState([]);
  const [preferedTimeSlot, setPreferedTimeSlot] = useState([]);
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const isFormInable = (values, errors) => {
    if (
      errors &&
      Object.keys(errors).length === 0 &&
      values.firstName &&
      values.email
    ) {
      return false;
    } else {
      return true;
    }
  };

  // form validation rules
  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .email()
      .typeError("Please provide valid email")
      .required("Email is required"),
    phone: Yup.string()
      .matches(phoneRegExp, "Contact Number number is not valid")
      .min(9)
      .max(15)
      .required("Contact Number is required"),
    fromCountryId: Yup.string().required("Field is required"),
    preferredCountryId: Yup.string().required("Field is required"),
    levelId: Yup.string().required("Field is required"),
    counsellingTimeId: Yup.string().required("Field is required"),
    preferredMonthYear: Yup.string().required("Field is required"),
    counsellingDate: Yup.string().required("Field is required"),
    terms_and_condition1: Yup.bool().oneOf(
      [true],
      "You must accept the terms and conditions"
    ),
    terms_and_condition2: Yup.bool().oneOf(
      [true],
      "You must accept the terms and conditions"
    ),
    terms_and_condition3: Yup.bool().oneOf(
      [true],
      "You must accept the terms and conditions"
    ),
  });

  // all country
  const getAllCountry = async () => {
    await API.get("/public/country/dropdown").then((res) => {
      if (!res.error) {
        setAllCountry(res.data);
      }
    });
  };

  // workable country
  const getWorkableCountry = async () => {
    await API.get("/public/country/workable").then((res) => {
      if (!res.error) {
        const { data } = res;
        setWorkableCountry(
          data.map((item) => {
            return {
              label: item?.name,
              value: item?.countryId,
            };
          })
        );
      }
    });
  };

  // get study level
  const getStudyLevel = async () => {
    await API.get("/public/course-level").then((res) => {
      if (!res.error) {
        const { data } = res;
        setStudyLevel(
          data.map((item) => {
            return {
              label: item?.levelName,
              value: item?.levelId,
            };
          })
        );
      }
    });
  };

  const getMonth = () => {
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let currentYear = new Date().getFullYear();
    let currMonth_id = new Date().getMonth();

    let next = [];
    let prev = [];

    for (let i = currMonth_id + 1; i < 12; i++) {
      let nextMonth_id = (currMonth_id + i) % 12;
      next.push({
        month: months[i],
        id: nextMonth_id + 1,
        year: currentYear,
      });
    }
    for (let j = currMonth_id; j >= 0; j--) {
      let prevMonth_id = (currMonth_id + j) % 12;
      prev.push({
        month: months[j],
        id: prevMonth_id,
        year: currentYear + 1,
      });
    }

    const timeSlot = next.concat(prev.reverse());

    setPlan(
      timeSlot.map((item) => {
        return {
          label: `${item?.month} - ${item?.year}`,
          value: `${item?.month}-${item?.year}`,
        };
      })
    );
  };

  const getTimeSlot = async (e) => {
    const { value } = e.target;
    setPreferedTimeSlot([]);
    await API.post("/public/virtual-counselling/get-preferred-time-slot", {
      counsellingDate: value,
    })
      .then((res) => {
        if (!res.error) {
          setPreferedTimeSlot(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = async (values, actions) => {
    setLoading(true);
    delete values.terms_and_condition1;
    delete values.terms_and_condition2;
    delete values.terms_and_condition3;
    let monthYear = values?.preferredMonthYear?.split("-");
    const payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
      fromCountryId: values.fromCountryId,
      preferredCountryId: values.preferredCountryId,
      levelId: values.levelId,
      counsellingTimeId: values.counsellingTimeId,
      preferredMonth: monthYear[0],
      preferredYear: monthYear[1],
      counsellingDate: values.counsellingDate,
    };
    await API.post("/public/virtual-counselling", payload)
      .then((res) => {
        if (!res.error) {
          swalSuccess("Successfully Submitted");
          actions.resetForm();
        } else {
          swalError("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
        swalError("Something went wrong");
      });
    setLoading(false);
  };

  useEffect(() => {
    getAllCountry();
    getWorkableCountry();
    getStudyLevel();
    getMonth();
  }, []);

  return (
    <>
      <section id="form">
        <div className="container">
          <div className={styles.form_wrapper}>
            <div className={styles.form_title_wrapper}>
              <h2>Interested in Free Virtual Counselling?</h2>
              <p>Please fill in your details and we’ll be in touch!</p>
            </div>
            <Formik
              initialValues={virtualState}
              enableReinitialize={true}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => {
                handleSubmit(values, actions);
              }}
            >
              {({ handleSubmit, values, setFieldValue, errors, touched }) => (
                <Form className="form" autoComplete="off">
                  <Grid container columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                    <Grid item xs={12} sm={6} md={6}>
                      <div className={styles.form_group}>
                        <label>
                          First Name <span className={styles.asterisk}>*</span>
                        </label>
                        <input
                          id="firstName"
                          name="firstName"
                          placeholder="First Name"
                          type="text"
                          value={values.firstName}
                          onChange={(e) => {
                            setFieldValue("firstName", e.target.value);
                            touched.firstName = true;
                          }}
                        />
                        {errors.firstName && touched.firstName && (
                          <div className={styles.error_msg}>
                            {errors.firstName}
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <div className={styles.form_group}>
                        <label>
                          Last Name <span className={styles.asterisk}>*</span>
                        </label>
                        <input
                          id="lastName"
                          name="lastName"
                          placeholder="Last Name"
                          type="text"
                          value={values.lastName}
                          onChange={(e) => {
                            setFieldValue("lastName", e.target.value);
                            touched.lastName = true;
                          }}
                        />
                        {errors.lastName && touched.lastName && (
                          <div className={styles.error_msg}>
                            {errors.lastName}
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <div className={styles.form_group}>
                        <label>
                          Email Address
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <input
                          id="email"
                          name="email"
                          placeholder="Type Your Email "
                          type="email"
                          value={values.email}
                          onChange={(e) => {
                            setFieldValue("email", e.target.value);
                            touched.email = true;
                          }}
                        />
                        {errors.email && touched.email && (
                          <div className={styles.error_msg}>{errors.email}</div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <div className={styles.form_group}>
                        <label>
                          Phone Number
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <input
                          id="firstName"
                          name="phone"
                          placeholder="Type Your Phone Number"
                          type="text"
                          value={values.phone}
                          onChange={(e) => {
                            setFieldValue("phone", e.target.value);
                            touched.phone = true;
                          }}
                        />
                        {errors.phone && touched.phone && (
                          <div className={styles.error_msg}>{errors.phone}</div>
                        )}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                      <div className={`${styles.form_group}`}>
                        <label>
                          Where are you from?
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <Select
                          instanceId="fromCountryId"
                          styles={customStyles}
                          placeholder="Please Select"
                          options={allCountry ?? []}
                          name="fromCountryId"
                          onChange={(item) => {
                            setFieldValue("fromCountryId", item.value);
                            touched.fromCountryId = true;
                          }}
                          value={
                            allCountry
                              ? allCountry.filter(
                                  (item) => item.value == values?.fromCountryId
                                )
                              : {}
                          }
                        />
                        {errors.fromCountryId && touched.fromCountryId && (
                          <div className={styles.error_msg}>
                            {errors.fromCountryId}
                          </div>
                        )}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                      <div className={`${styles.form_group}`}>
                        <label>
                          Your preferred study destination
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <Select
                          instanceId="preferredCountryId"
                          styles={customStyles}
                          placeholder="Please Select"
                          options={workableCountry ?? []}
                          name="preferredCountryId"
                          onChange={(item) => {
                            setFieldValue("preferredCountryId", item.value);
                            touched.preferredCountryId = true;
                          }}
                          value={
                            workableCountry
                              ? workableCountry.filter(
                                  (item) =>
                                    item.value == values?.preferredCountryId
                                )
                              : {}
                          }
                        />
                        {errors.preferredCountryId &&
                          touched.preferredCountryId && (
                            <div className={styles.error_msg}>
                              {errors.preferredCountryId}
                            </div>
                          )}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                      <div className={`${styles.form_group}`}>
                        <label>
                          Preferred study level
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <Select
                          instanceId="levelId"
                          styles={customStyles}
                          placeholder="Please Select"
                          options={studyLevel ?? []}
                          name="levelId"
                          onChange={(item) => {
                            setFieldValue("levelId", item.value);
                            touched.levelId = true;
                          }}
                          value={
                            studyLevel
                              ? studyLevel.filter(
                                  (item) => item.value == values?.levelId
                                )
                              : {}
                          }
                        />
                        {errors.levelId && touched.levelId && (
                          <div className={styles.error_msg}>
                            {errors.levelId}
                          </div>
                        )}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                      <div className={`${styles.form_group}`}>
                        <label>
                          When do you plan to study?
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <Select
                          instanceId="preferredMonthYear"
                          styles={customStyles}
                          placeholder="Please Select"
                          options={plan ?? []}
                          name="preferredMonthYear"
                          onChange={(item) => {
                            setFieldValue("preferredMonthYear", item.value);
                            touched.preferredMonthYear = true;
                          }}
                          value={
                            plan
                              ? plan.filter(
                                  (item) =>
                                    item.value == values?.preferredMonthYear
                                )
                              : {}
                          }
                        />
                        {errors.preferredMonthYear &&
                          touched.preferredMonthYear && (
                            <div className={styles.error_msg}>
                              {errors.preferredMonthYear}
                            </div>
                          )}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <div className={`${styles.form_group}`}>
                        <label>
                          Preferred date of counselling
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <StudentProfileInput
                          inputType="date"
                          label="none"
                          min={new Date()}
                          name="counsellingDate"
                          className={styles.date_input}
                          selected={values.counsellingDate ?? ""}
                          onChange={(e) => {
                            setFieldValue("counsellingDate", e.target.value);
                            getTimeSlot(e);
                            touched.counsellingDate = true;
                          }}
                        />
                        {errors.counsellingDate && touched.counsellingDate && (
                          <div className={styles.error_msg}>
                            {errors.counsellingDate}
                          </div>
                        )}
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                      <div className={`${styles.form_group}`}>
                        <label>
                          Preferred time slot
                          <span className={styles.asterisk}>*</span>
                        </label>
                        <Select
                          instanceId="counsellingTimeId"
                          styles={customStyles}
                          placeholder="Please Select"
                          options={preferedTimeSlot ?? []}
                          name="name"
                          onChange={(item) => {
                            setFieldValue("counsellingTimeId", item.value);
                            touched.counsellingTimeId = true;
                          }}
                          value={
                            preferedTimeSlot
                              ? preferedTimeSlot.filter(
                                  (item) =>
                                    item.value == values?.counsellingTimeId
                                )
                              : {}
                          }
                        />
                        {errors.counsellingTimeId &&
                          touched.counsellingTimeId && (
                            <div className={styles.error_msg}>
                              {errors.counsellingTimeId}
                            </div>
                          )}
                      </div>
                    </Grid>
                  </Grid>

                  <div className={styles.checkbox_container_wrapper}>
                    <div className={styles.checkbox_alert_text}>
                      UniSearch will not share your details with others without
                      your permission:
                    </div>

                    <div className={styles.checkbox_with_error_wrapper}>
                      <div className={styles.checkbox_wrapper}>
                        <label className={styles.checkbox_lebel} html="terms">
                          <Field
                            id="terms"
                            type="checkbox"
                            name="terms_and_condition1"
                            className="checkbox disable-team team_values"
                            value={true}
                            checked={
                              values.terms_and_condition1 &&
                              values.terms_and_condition1 === true
                                ? true
                                : false
                            }
                            onChange={(event) => {
                              setFieldValue(
                                "terms_and_condition1",
                                !values.terms_and_condition1
                              );
                              touched.terms_and_condition1 = true;
                            }}
                          />
                          <span>I agree to UniSearch</span>
                        </label>
                        <Link legacyBehavior href="/terms-and-conditions">
                          <a className={styles.term_link}>Terms</a>
                        </Link>
                        <span>and</span>
                        <Link legacyBehavior href="/privacy-policy">
                          <a className={styles.term_link}>Privacy Policy.</a>
                        </Link>
                      </div>
                      {errors.terms_and_condition1 &&
                        touched.terms_and_condition1 && (
                          <div className={styles.error_msg}>
                            {errors.terms_and_condition1}
                          </div>
                        )}
                    </div>

                    <div className={styles.checkbox_with_error_wrapper}>
                      <div className={styles.checkbox_wrapper}>
                        <label className={styles.checkbox_lebel} html="contact">
                          <Field
                            id="terms"
                            type="checkbox"
                            name="terms_and_condition2"
                            className="checkbox disable-team team_values"
                            value={true}
                            checked={
                              values.terms_and_condition2 &&
                              values.terms_and_condition2 === true
                                ? true
                                : false
                            }
                            onChange={(event) => {
                              setFieldValue(
                                "terms_and_condition2",
                                !values.terms_and_condition2
                              );
                              touched.terms_and_condition2 = true;
                            }}
                          />
                          <span>
                            Please contact me by phone, email or SMS to assist
                            with my enquiry
                          </span>
                        </label>
                      </div>
                      {errors.terms_and_condition2 &&
                        touched.terms_and_condition2 && (
                          <div className={styles.error_msg}>
                            {errors.terms_and_condition2}
                          </div>
                        )}
                    </div>

                    <div className={styles.checkbox_with_error_wrapper}>
                      <div className={styles.checkbox_wrapper}>
                        <label className={styles.checkbox_lebel} html="update">
                          <Field
                            id="terms"
                            type="checkbox"
                            name="terms_and_condition3"
                            className="checkbox disable-team team_values"
                            value={true}
                            checked={
                              values.terms_and_condition3 &&
                              values.terms_and_condition3 === true
                                ? true
                                : false
                            }
                            onChange={(event) => {
                              setFieldValue(
                                "terms_and_condition3",
                                !values.terms_and_condition3
                              );
                              touched.terms_and_condition3 = true;
                            }}
                          />
                          <span>
                            I would like to receive updates and offers from
                            UniSearch
                          </span>
                        </label>
                      </div>
                      {errors.terms_and_condition3 &&
                        touched.terms_and_condition3 && (
                          <div className={styles.error_msg}>
                            {errors.terms_and_condition3}
                          </div>
                        )}
                    </div>
                  </div>

                  <button
                    type="submit"
                    className={`${
                      styles.register_btn
                    } btn btn-secondary btn-bg btn-full ${
                      loading || isFormInable(values, errors)
                        ? styles.disabled
                        : "enable"
                    } `}
                    onClick={handleSubmit}
                    disabled={
                      loading || isFormInable(values, errors) ? true : false
                    }
                  >
                    {loading && (
                      <CircularProgress size="20px" color="inherit" />
                    )}{" "}
                    Register Now!
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </section>

      {/* Modal */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="modal sm">
          <button
            style={{
              position: "absolute",
              top: "24px",
              right: "10px",
            }}
            className="cross_icon"
            onClick={handleClose}
          >
            <FiX />
          </button>

          <div className={styles.success_modal_wrapper}>
            <ReactSVG
              className={styles.checked_icon}
              src={getAssets("assets/images/voffice/success-checked.svg")}
            />
            <h4 className={styles.success_title}>Registration Success!</h4>
            <p className={styles.success_text}>
              Your Registration has been successfully done.
            </p>
            <div className={styles.success_btn}>
              <button className="btn btn-secondary btn-bg">Continue</button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default VOfficeForm;
